<template>
  <main>
    <ReviewsSection />
  </main>
</template>

<script>
import ReviewsSection from '../components/ReviewsSection.vue'

export default {
  name: 'ReviewsPage',
  components: {
    ReviewsSection
  }
}
</script>
